import { render, staticRenderFns } from "./developerAccount.vue?vue&type=template&id=52c9514c&"
import script from "./developerAccount.vue?vue&type=script&lang=js&"
export * from "./developerAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports